import type { ReputationVerdict } from "@sage/shared";

export interface VerdictBadgeProps {
  verdict: ReputationVerdict;
  compact?: boolean;
}

export function VerdictBadge({ verdict, compact }: VerdictBadgeProps) {
  return (
    <span class={`verdict verdict-${verdict}${compact ? " verdict-compact" : ""}`}>
      Verdict: {verdict}
    </span>
  );
}
